import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { toast } from "sonner";

export function PostComposer({ bookId, listId, onCreated }) {
  const [tur, setTur] = useState("Yorum");
  const [icerik, setIcerik] = useState("");
  const [spoiler, setSpoiler] = useState(false);
  const [sayfa, setSayfa] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!icerik.trim()) return;
    setLoading(true);
    try {
      await api.post("/posts", { book_id: bookId, reading_list_id: listId, tur, icerik, spoiler_mi: spoiler, sayfa: tur === "Alıntı" && sayfa ? Number(sayfa) : null });
      setIcerik(""); setSpoiler(false); setSayfa("");
      toast.success("Paylaşımın eklendi.");
      onCreated?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="border border-line rounded-lg p-4 bg-surface-alt/50" data-testid="post-composer">
      <ToggleGroup type="single" value={tur} onValueChange={(v) => v && setTur(v)} className="justify-start mb-3 flex-wrap gap-2">
        {["Yorum", "Alıntı", "Abstract"].map((t) => (
          <ToggleGroupItem key={t} value={t} data-testid={`post-type-${t}`}
            className="rounded-full border border-line px-4 data-[state=on]:bg-terra data-[state=on]:text-white text-ink-2">
            {t}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <Textarea data-testid="post-content" value={icerik} onChange={(e) => setIcerik(e.target.value)} rows={3}
        placeholder={tur === "Alıntı" ? "Beğendiğin bir pasajı paylaş..." : "Düşüncelerini yaz..."} className="bg-surface" />
      {tur === "Alıntı" && (
        <div className="flex items-center gap-2 mt-3">
          <label className="text-sm text-ink-2">Sayfa no (opsiyonel)</label>
          <input type="number" min={1} data-testid="post-page" value={sayfa} onChange={(e) => setSayfa(e.target.value)}
            placeholder="örn. 42" className="w-24 h-9 rounded-md border border-line bg-surface px-2 text-sm" />
        </div>
      )}
      <div className="flex items-center justify-between mt-3">
        <label className="flex items-center gap-2 text-sm text-ink-2 cursor-pointer">
          <Checkbox checked={spoiler} onCheckedChange={setSpoiler} data-testid="post-spoiler" /> Spoiler içerir
        </label>
        <Button type="submit" disabled={loading} data-testid="post-submit"
          className="bg-terra hover:bg-terra-hover text-white rounded-full px-5">
          {loading ? "..." : "Paylaş"}
        </Button>
      </div>
    </form>
  );
}

export function StarRating({ value, onChange, size = 22 }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((s) => (
        <button key={s} type="button" data-testid={`star-${s}`}
          onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
          onClick={() => onChange(s)} className="transition-transform hover:scale-110">
          <svg width={size} height={size} viewBox="0 0 24 24"
            fill={(hover || value) >= s ? "#D4AF37" : "none"} stroke="#D4AF37" strokeWidth="1.5">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      ))}
    </div>
  );
}
